<template>
    <v-container fluid>
      <el-overlay-loading :loading="pageloading" />
      <!-- title  -->
      <h1 class="mb-1">{{ $t(getTitle) }}</h1>
      <!-- form  -->
      <v-card outlined class="mb-4">
        <form @keydown.enter.prevent="submit()">
          <v-card-text class="mt-5">
            <v-row class="mb-0 pb-0">
              <v-col class="pb-0" cols="12" md="12">
                <el-text-field
                  label="Pavadinimas (LT)"
                  v-model="formData.title_lt"
                  :disabled="modeReadonly"
                  :maxlength="50"
                  required
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="12">
                <el-text-field
                  label="Pavadinimas (EN)"
                  v-model="formData.title_en"
                  :disabled="modeReadonly"
                  :maxlength="50"
                  required
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="4" lg="3">
                <el-text-field
                  label="Trumpinys"
                  v-model="formData.code"
                  :disabled="modeReadonly"
                  :maxlength="10"
                  required
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="4" lg="3">
                <el-date-picker
                  label="Galioja nuo"
                  required
                  :disabled="modeReadonly"
                  v-model="formData.valid_from"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="4" lg="3">
                <el-date-picker
                  label="Galioja iki"
                  :afterDate="formData.valid_from"
                  :disabled="modeReadonly"
                  v-model="formData.valid_to"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <el-button
                class="mr-1"
                color="secondary"
                icon="atšaukti"
                title="Atšaukti"
                @click.native.stop="back()"
                :loading="loading"
              />
              <el-button
                v-if="!modeReadonly"
                title="Išsaugoti"
                :loading="loading"
                @click.native="saveData()"
                color="primary"
                icon="išsaugoti"
              />
            </v-row>
          </v-card-actions>
        </form>
      </v-card>
      <!-- modal  -->
      <modal-delete
        title="Įrašo šalinimas"
        :text="`Ar tikrai norite pašalinti?`"
        v-model="showDelete"
        :item="modalDeleteItem"
        @confirmDelete="confirmDelete"
      />
    </v-container>
  </template>
  
  <script>
  import userRole from '@/mixins/userRole'
  import ModalDelete from '@/components/modals/ModalDelete'
  
  export default {
    name: 'PersonDocumentKindForm',
    components: {
      ModalDelete,
    },
    mixins: [userRole],
    $_veeValidate: {
      validator: 'new',
    },
    data() {
      return {
        pageloading: false,
        loading: false,
        formData: {},
        personDocumentKindsList: [],
        showDelete: false,
        modalDeleteItem: null,
        code: '',
      }
    },
    computed: {
      modeReadonly() {
        return false
      },
      getId() {
        return this.$route.params.id || null
      },
      getTitle() {
        if (this.getId) {
          return this.$t(`Redaguoti asmens dokumento rūšį`)
        } else {
          return this.$t(`Nauja asmens dokumento rūšis`)
        }
      },
    },
    beforeDestroy() {},
    created() {
      if (this.getId) {
        this.getData()
      } 
    },
    methods: {
      itemRowBackground: function (item) {
        return item.type && 'newly-added-row'
      },
      setEdit(item) {
        item.canDelete = true
        return item
      },
      back() {
        this.$router.push({ name: 'personDocumentKind' })
      },
      getData() {
        this.pageloading = true
        this.$axios
          .get(`person-document-kinds/${this.getId}`)
          .then((res) => {
            this.formData = res.data.personDocumentKind
            this.code = this.formData.code
            this.personDocumentKindsList = this.formData.personDocumentKinds
          })
          .catch((err) => {
            this.$root.$emit('DATA_ERROR', err)
          })
          .finally(() => {
            this.pageloading = false
          })
      },
      saveData() {
        this.$validator.validateAll().then((res) => {
          if (res) {
            this.loading = true
            let formData = this.formData
            let url = `person-document-kinds`
            this.getId && (formData.id = this.getId)
            this.$axios
              .post(url, formData)
              .then((res) => {
                this.$root.$emit('DATA_OK_CODE', '000110')
                this.back()
              })
              .catch((err) => {
                this.$root.$emit('DATA_ERROR', err)
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            this.$root.$emit('FORMAT_ERROR')
          }
        })
      },
      deleteItem(item) {
        this.modalDeleteItem = Object.assign({}, item)
        this.showDelete = true
      },
      confirmDelete(item) {
        const index = this.personDocumentKindsList.findIndex(
          (formItem) => formItem.id === item.item.id
        )
        if (index > -1) {
          this.personDocumentKindsList.splice(index, 1)
        }
        this.showDelete = false
      },
    },
  }
  </script>
  <style lang="scss"></style>
  